import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNumeric',
    standalone: false,
})
export class IsNumericPipe implements PipeTransform {
    transform(value: any): boolean {
        return !isNaN(+value);
    }
}
